/**
 * @generated SignedSource<<5b446f8b8f330e02428d3bbd2a53a1a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ControlChangeUserEmailInput = {
  newEmail: string;
  reason: string;
  userId: string;
};
export type ControlChangeUserEmailModalMutation$variables = {
  input: ControlChangeUserEmailInput;
};
export type ControlChangeUserEmailModalMutation$data = {
  readonly controlChangeUserEmail: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type ControlChangeUserEmailModalMutation = {
  response: ControlChangeUserEmailModalMutation$data;
  variables: ControlChangeUserEmailModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ControlChangeUserEmailResponse",
    "kind": "LinkedField",
    "name": "controlChangeUserEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ControlUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ControlChangeUserEmailModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ControlChangeUserEmailModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d1b326add2d8f6877f0cecb98b17e9ae",
    "id": null,
    "metadata": {},
    "name": "ControlChangeUserEmailModalMutation",
    "operationKind": "mutation",
    "text": "mutation ControlChangeUserEmailModalMutation(\n  $input: ControlChangeUserEmailInput!\n) {\n  controlChangeUserEmail(input: $input) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ceb8dbeb2ba7ce9ca9379f7f51e2988";

export default node;
